import QuillDelta from 'quill-delta';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';

import { useHistory } from '@treams/treams-routes';

import * as graphql from 'generated/graphql';

import Modal, {
	ModalBackground,
	ModalContent,
} from '../../../kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from '../../../kakapo-ui-kit/components/modals/ModalHeader';
import QuillField from '../../../kakapo-ui-kit/components/editors/QuillField';
import Label from '../../../kakapo-ui-kit/components/forms/controls/Label';
import { Button } from '@treams/treams-ui';

const quillValidator = Yup.object({
	ops: Yup.array().min(1).required(),
});

export function ComplimentCreateModalWithID(props: { userID: string }) {
	const query = graphql.useUserQuery({ variables: { id: props.userID } });

	return query.data ? <ComplimentCreateModal user={query.data.user as graphql.User} /> : null;
}

export default function ComplimentCreateModal({ user }: { user: graphql.User }) {
	const history = useHistory();
	const { t } = useTranslation();
	const returnUrl = `/users/${user.id}/feedback/compliments`;

	const [create, { loading }] = graphql.useCreateComplimentMutation();

	const createCompliment = async (text: QuillDelta) => {
		await create({
			variables: {
				input: {
					userID: user.id,
					text,
				},
			},
		});

		history.push(`/user/${user.id}/compliments/thank-you`);
	};

	const formik = useFormik({
		initialValues: { text: new QuillDelta() },
		validationSchema: Yup.object({
			text: quillValidator.required(),
		}).required(),
		onSubmit: (values) => {
			createCompliment(values.text);
		},
	});

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader
					onCancel={() => {
						history.push(returnUrl);
					}}
				>
					<ModalHeaderTitle>
						{t('compliments.give.title', { firstName: user.firstName })}
					</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					<FormikProvider value={formik}>
						<Form>
							<Label title={t('compliments.give.textField.label')} />
							<QuillField name="text" boxedStyling />

							<Flex flexDirection="row" justifyContent="flex-end" mt={4}>
								{returnUrl && (
									<Box mr={2}>
										<Button
											type="secondary"
											onClick={() => {
												history.push(returnUrl);
											}}
											title={t('shared-goals.create.modal.cancel')}
										/>
									</Box>
								)}

								<Box>
									<input type="submit" style={{ display: 'none' }} />
									<Button
										title={t('compliments.give.button.create')}
										onClick={() => {
											formik.submitForm();
										}}
										loading={loading}
									/>
								</Box>
							</Flex>
						</Form>
					</FormikProvider>
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
